import { useCallback, useEffect, useState } from 'react'

export function useResizeHeight(minHeight, initialSize, maxHeight) {

  const [isResizing, setIsResizing] = useState(false)
  const [height, setheight] = useState(initialSize)

  const enableResize = useCallback(() => {
    setIsResizing(true)
  }, [setIsResizing])

  const disableResize = useCallback(() => {
    setIsResizing(false)
  }, [setIsResizing])

  const resize = useCallback(
    (e) => {
      if (isResizing) {
        let newHeight = 0
        let newMaxHeight = 0
        if (document?.getElementsByClassName('baseLine')[0] !== undefined) {
          console.log('1')
          newHeight = (document.getElementsByClassName('baseLine')[0].offsetHeight - (e.clientY - document.body.offsetHeight))
        } else {
          console.log('2')
          console.log(document.getElementById('tableParent'))
          newHeight = document.body.offsetHeight === 0 ? -80 - (e.clientY - window.screen.height) : - (e.clientY - document.body.offsetHeight)
        }

        if (document?.body?.getElementsByClassName('divTabs')[0] !== undefined) {

          newMaxHeight = document.body.offsetHeight - (document.body.getElementsByClassName('divTabs')[0].offsetHeight + maxHeight)
        }
        setheight(newHeight)
        // if (newHeight >= minHeight && newHeight <= newMaxHeight) {
        //   console.log('TESTE')
        // }
      }
    },
    [minHeight, isResizing, setheight],
  )

  useEffect(() => {
    document.addEventListener('mousemove', resize)
    document.addEventListener('mouseup', disableResize)

    return () => {
      document.removeEventListener('mousemove', resize)
      document.removeEventListener('mouseup', disableResize)
    }
  }, [disableResize, resize])
  return { height, enableResize }
}
